import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TEST_IDS } from "@/constants/testIds";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useT } from "@/i18n/LanguageContext";

const linkIds = [
  { id: "the-house", key: "theHouse", testId: TEST_IDS.nav.linkDiamonds },
  { id: "expert-focus", key: "expertFocus", testId: TEST_IDS.nav.linkStones },
  { id: "process", key: "process", testId: TEST_IDS.nav.linkSourcing },
  { id: "offering", key: "offering", testId: TEST_IDS.nav.linkCertification },
  { id: "trust", key: "trust", testId: TEST_IDS.nav.linkHome },
  { id: "contact", key: "contact", testId: TEST_IDS.nav.linkContact },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useT();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    if (location.pathname !== "/") {
      navigate(id === "top" ? "/" : `/#${id}`);
      return;
    }
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid={TEST_IDS.nav.root}
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/70 border-b border-white/60"
          : "bg-transparent"
      }`}
    >
      <div className="container-luxe flex items-center justify-center md:justify-between py-5">
        <button
          onClick={() => handleNav("top")}
          data-testid={TEST_IDS.nav.logo}
          className="group flex items-center gap-3 shrink-0"
        >
          <img
            src="/ck-emblem.svg"
            alt="Coumba Kandji Diamonds emblem"
            className="h-10 md:h-11 w-auto object-contain"
          />
        </button>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9">
          {linkIds.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => handleNav(l.id)}
              className="font-mono text-[10px] uppercase tracking-[0.28em] text-muted_text hover:text-ink transition-colors"
            >
              {t(`nav.${l.key}`)}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-6">
          <LanguageSwitcher />
        </div>
      </div>
    </motion.header>
  );
};
